import { useContext } from "react"
import { Contact } from "lucide-react"
import styles from "./contactInformationCard.module.css"
import { TemplateContext } from "../../../../../../../../contexts/TemplateContext"
import type React from "react"

export default function ContactInformationCard() {
  const { template, setTemplate } = useContext(TemplateContext)

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!template) return;
    
    const { name, value } = e.target
    
    setTemplate({
      ...template,
      ContactInformation: {
        ...template.ContactInformation,
        [name]: value,
      },
    })
  }
  
  if (!template) {
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <Contact className={styles.icon} />
          <h1>Contact Info</h1>
        </div>
        <div className={styles.form}>
          <p>Loading contact information...</p>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Contact className={styles.icon} />
        <h1>Contact Info</h1>
      </div>

      <div className={styles.form}>
        <div className={styles.field}>
          <label>Contact Name </label>
          <input 
            type="text" 
            name="Name" 
            value={template.ContactInformation.Name} 
            onChange={handleInputChange} 
          />
        </div>

        <div className={styles.field}>
          <label>Phone </label>
          <input
            type="tel"
            name="PhoneNumber"
            value={template.ContactInformation.PhoneNumber}
            onChange={handleInputChange}
          />
        </div>

        <div className={styles.field}>
          <label>Email </label>
          <input 
            type="email" 
            name="Email" 
            value={template.ContactInformation.Email} 
            onChange={handleInputChange} 
          />
        </div>

        <div className={styles.field}>
          <label>Pentest Company </label>
          <input 
            type="text" 
            name="Company" 
            value={template.ContactInformation.Company} 
            onChange={handleInputChange} 
          />
        </div>
      </div>
    </div>
  )
}